// extracted by extract-css-chunks-webpack-plugin
module.exports = {"startShopping":"eZFnd","itemsViewed":"MVNof","earnPoints":"cLcoD"};